import React, { useState } from "react";
import { getBanklink } from "../../../action/userAction";
import { showMessage } from "../../../utils/toast/globalToast";
import { _toastVariants } from "../../../utils/Constant";

const BankLinkTab = ({ bankData }) => {


  const isStripeLinked = bankData?.linked || false;

  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (isStripeLinked) return;

    setLoading(true);
    try {
      const res = await getBanklink();

      if (res?.success && res?.data?.url) {
        window.location.href = res.data.url; 
      } else {
        showMessage({
          variant: _toastVariants.Error,
          message: "Unable to fetch bank link. Please try again.",
        });
      }
    } catch (error) {
      console.error("Error getting bank link:", error);
      showMessage({
        variant: _toastVariants.Error,
        message: "Something went wrong while connecting Stripe.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="row mt-4">
      <div className="col-12">
        {/* ✅ Status Display */}
        <div className="d-flex align-items-center justify-content-between mb-3">
          <h6 className="mb-0">
             Account:{" "}
            {isStripeLinked ? (
              <span className="text-success fw-semibold">Linked ✅</span>
            ) : (
              <span className="text-danger fw-semibold">Not Linked ❌</span>
            )}
          </h6>
        </div>

        {/* ✅ Action Button */}
        <div className="text-end">
          <button
            type="button"
            className={`btn ${isStripeLinked ? "btn-secondary" : "btn-success"}`}
            disabled={isStripeLinked || loading}
            onClick={handleClick}
            style={{
              cursor: isStripeLinked || loading ? "not-allowed" : "pointer",
            }}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Loading...
              </>
            ) : isStripeLinked ? (
              "Bank Linked"
            ) : (
              "+ Add Bank Link"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BankLinkTab;
